module.exports = __webpack_public_path__ + "img/icon-export-expenses.f4bea2d6.svg";